export default "__VITE_PUBLIC_ASSET__878ceae5__"